import {pageInfo, initPage, initUpdate,getDeleteDeliveryWarehouse,exportData,downtemplate,updateDeliveryWarehouseUpload,deliveryWarehouseUpLoad} from './../api';
import { Message } from 'element-ui';
const deliveryWarehouse = {
  namespaced: true,
  state: {
    total:0,
    resp:null,
    pageResp:null,
    initPageObj: null,
    initUpdateObj: null,
    deleteDeliveryWarehouse:null,
    exportObj:null,
    deliveryWarehouseResp:null,
    templateObj:null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    GET_DELETE_DELIVERYWAREHOUSE(state,data){
      state.deleteDeliveryWarehouse = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.deliveryWarehouseResp = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    async getDeleteDeliveryWarehouse({commit}, obj){
      let resp = await getDeleteDeliveryWarehouse(obj);
      commit('GET_DELETE_DELIVERYWAREHOUSE', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },    //导入数据
    async deliveryWarehouseUpLoad({ commit }, obj) {
      let resp = await updateDeliveryWarehouseUpload(obj);
      commit('UPLOAD_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
  }
}
export default deliveryWarehouse



// WEBPACK FOOTER //
// ./src/page/md/deliveryWarehouse/store/deliveryWarehouse.store.js